import React from "react";
import Marquee from "react-fast-marquee";
import { useContent } from "@/context/ContentContext";

export default function KineticMarquee() {
  const { content } = useContent() || {};
  const text = content?.marquee?.text || "Long Lasting Memory ✦ Long Lasting Memory ✦";
  return (
    <section
      data-testid="kinetic-marquee"
      className="relative py-10 md:py-16 border-y border-white/10 bg-[#050505] overflow-hidden"
    >
      <Marquee speed={45} gradient={false} pauseOnHover>
        <span
          className="font-display italic text-[#f5f5f5] kinetic-stroke whitespace-nowrap pr-12"
          style={{ fontSize: "clamp(4rem, 14vw, 14rem)", lineHeight: 1 }}
        >
          {text}
        </span>
      </Marquee>
    </section>
  );
}
